import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Link, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import './HeaderFooter.css'; // Import your CSS file for styling
import { UserContext } from '../Context';
import { BASE_URL } from '../utils/config';

const Header = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);
  const [cartItemsCount, setCartItemsCount] = useState(0);

  useEffect(() => {
    const fetchCartCount = () => {
      const customerId = localStorage.getItem('customer_id');
      if (customerId) {
        fetch(`${BASE_URL}/api/cart/${customerId}/`)
          .then(res => res.json())
          .then(data => {
            if (data.bool && data.data) {
              const totalCount = data.data.reduce((acc, item) => acc + (item.quantity || 1), 0);
              setCartItemsCount(totalCount);
            } else {
              setCartItemsCount(0);
            }
          })
          .catch(err => console.error("Error fetching cart count:", err));
      } else {
        setCartItemsCount(0);
      }
    };

    fetchCartCount();
    window.addEventListener('cartUpdated', fetchCartCount);
    return () => window.removeEventListener('cartUpdated', fetchCartCount);
  }, []);

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem('customer_login');
    localStorage.removeItem('customer_username');
    localStorage.removeItem('customer_id');
    localStorage.removeItem('user');
    localStorage.removeItem('admin_login');
    setUser({ login: false }); // Reset UserContext
    navigate('/login');
  };

  // Check if user is logged in (customer or admin)
  const isLoggedIn = 
    localStorage.getItem('customer_login') === 'true' || 
    localStorage.getItem('admin_login') === 'true' ||
    localStorage.getItem('employee_login') === 'true';

  const [searchQuery, setSearchQuery] = React.useState('');

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery(''); // Optionally clear the search input after searching
    }
  };

  return (
    <header className='main-top-bar'>
      <div className="home-top-bar">
        <div className="home-container">
          <div className="home-contact-info">
            <br></br>
            <ul>
              <li><i className="fas fa-phone"> </i> +91-9924184931</li>
              <li>
                <a href="mailto:bookepedia.business@gmail.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <i className="fas fa-envelope"> </i> bookepedia.business@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div className="link-right">
            <ul>
              {!isLoggedIn ? (
                <li>
                  <Nav.Link as={Link} to="/login" style={{ textDecoration: 'none', color: 'rgb(255, 255, 255)' }}>
                    <i className="fas fa-user-plus"> </i>Log/Sign Up
                  </Nav.Link>
                </li>
              ) : (
                <li>
                  <Nav.Link as={Link} to="#" onClick={handleLogout} style={{ textDecoration: 'none', color: 'rgb(255, 255, 255)' }}>
                    <i className="fas fa-sign-out-alt"> </i>Logout
                  </Nav.Link>
                </li>
              )}
              <li>
                <Nav.Link as={Link} to="/cart" style={{ textDecoration: 'none', color: 'white', position: 'relative' }}>
                  <i className="fas fa-shopping-cart"></i> Cart
                  {cartItemsCount > 0 && (
                    <span className="cart-badge-lux">
                      {cartItemsCount}
                    </span>
                  )}
                </Nav.Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Navbar (Link for pages) */}
      <div className="header">
        <nav className="navbar">
          <Link to="/" className="logo" style={{ textDecoration: 'none', color: 'inherit' }}>
            <i className="fa-solid fa-book-open-reader me-2"></i>
            <span>Book-E-Pedia</span>
          </Link>
          <ul className="nav-links">
            <li>
              <NavLink 
                to="/" 
                className={({ isActive }) => (isActive ? "active-link" : "")}>
                <i className="fa fa-home"></i> Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/categories" 
                className={({ isActive }) => (isActive ? "active-link" : "")}>
                <i className="fa-solid fa-icons"></i> Category
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/products" 
                className={({ isActive }) => (isActive ? "active-link" : "")}>
                <i className="fa-solid fa-basket-shopping"></i> Shop
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/aboutus" 
                className={({ isActive }) => (isActive ? "active-link" : "")}>
                <i className="fa fa-info-circle"></i> About Us
              </NavLink>
            </li>
            <li>
              <NavLink 
                to={isLoggedIn ? (localStorage.getItem('admin_login') === 'true' ? '/admin/dashboard' : '/customer/dashboard') : '/login'}
                className={({ isActive }) => (isActive ? "active-link" : "")}>
                <i className="fa fa-user"></i> Account
              </NavLink>
            </li>
          </ul>
        
          <form className="search-top-bar" onSubmit={handleSearchSubmit}>
            <input 
              type="text" 
              placeholder="What do you want to read?" 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit">Search</button>
          </form>
        </nav>
      </div>
    </header>
  );
};

export default Header;
